export function getRakingFilters() {
  return [
    "A-",
    "A",
    "A+",
    "B-",
    "B",
    "B+",
    "C-",
    "C",
    "C+",
    "D-",
    "D",
    "D+",
    "F",
  ];
}
